(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-slidercustom"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initHomeSlider(retries) {
    retries = retries || 0;

    if (typeof window.jQuery === 'undefined') {
      if (retries < 20) {
        setTimeout(function() { initHomeSlider(retries + 1); }, 200);
      }
      return;
    }

    var $ = window.jQuery;

    if (typeof $.fn.owlCarousel === 'undefined') {
      if (retries < 20) {
        setTimeout(function() { initHomeSlider(retries + 1); }, 200);
      }
      return;
    }

    var $slider = $('.custom-carousel');
    if (!$slider.length) return;

    $slider.owlCarousel({
      loop: true,
      dots: false,
      nav: false,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayHoverPause: true,
      autoHeight: true,
      responsive: {
        0: {
          items: 1,
          margin: 0     // No gap on mobile
        },
        1024: {
          items: 2,
          margin: 20    // 20px gap on desktop
        }
      }
    });

    $('.custom-next').on('click', function() {
      $slider.trigger('next.owl.carousel');
    });

    $('.custom-prev').on('click', function() {
      $slider.trigger('prev.owl.carousel');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHomeSlider();
    });
  } else {
    initHomeSlider();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-claim"] && !Shopify.designMode) return;
  try {
    
(function() {
  var form = document.getElementById('WarrantyClaimForm');
  if (!form) return;

  var nameEl = document.getElementById('WarrantyClaim-name');
  var emailEl = document.getElementById('WarrantyClaim-email');
  var orderEl = document.getElementById('WarrantyClaim-order');
  var problemEl = document.getElementById('WarrantyClaim-problem');
  var fileEl = document.getElementById('WarrantyClaim-video');
  var submitBtn = form.querySelector('[data-submit-btn]');
  var fileNameEl = form.querySelector('[data-file-name]');
  var fileErrEl = form.querySelector('[data-video-error]');

  function hasVideo() {
    return fileEl && fileEl.files && fileEl.files.length > 0;
  }

  function isValidBasic() {
    return (
      nameEl && nameEl.value.trim().length > 0 &&
      emailEl && emailEl.value.trim().length > 0 &&
      orderEl && orderEl.value.trim().length > 0 &&
      problemEl && problemEl.value.trim().length > 0
    );
  }

  function validate() {
    var ok = isValidBasic() && hasVideo();
    if (submitBtn) submitBtn.disabled = !ok;

    if (fileErrEl) {
      fileErrEl.classList.toggle('is-visible', !hasVideo() && !fileEl.disabled && (fileEl.dataset.touched === '1' || form.dataset.submitted === '1'));
    }
  }

  function markTouched() {
    if (!fileEl) return;
    fileEl.dataset.touched = '1';
    validate();
  }

  // Update file name
  if (fileEl) {
    fileEl.addEventListener('change', function() {
      if (fileNameEl) {
        fileNameEl.textContent = hasVideo() ? fileEl.files[0].name : 'No file selected';
      }
      markTouched();
    });
    fileEl.addEventListener('blur', markTouched);
  }

  // Listen to input changes
  [nameEl, emailEl, orderEl, problemEl].forEach(function(el) {
    if (!el) return;
    el.addEventListener('input', validate);
    el.addEventListener('blur', validate);
  });

  // Block submit if no video
  form.addEventListener('submit', function(e) {
    form.dataset.submitted = '1';
    if (!isValidBasic() || !hasVideo()) {
      e.preventDefault();
      validate();
      if (fileEl && !hasVideo()) fileEl.focus();
    }
  });

  // Initial
  validate();
})();

  } catch(e) { console.error(e); }
})();
})();
